export default __webpack_public_path__ + "static/media/icon-email.201ea9e2.svg";